import { styled } from '@linaria/react';
import { breakpoints } from '@spaceshipapp/cambridge';

export const ItemFormModalContainer = styled.span`
  & > * > [role='dialog'] {
    @media (min-width: ${breakpoints.md}) {
      inset: 0 !important;
      max-height: 90vh !important;
      overflow: auto !important;
      width: fit-content !important;
      margin: auto !important;
      padding: 0 !important;
    }
  }
`;
